import { Box, CardMedia, Typography, useMediaQuery } from "@mui/material"
import VibioGetStartedForm from "./VibioGetStartedForm"
import HeroMedia from "./HeroMedia"

export default function HeroSection() {
    const isMobile = useMediaQuery('(max-width:950px)')

    const styles = {
        container: (theme, isMobile) => ({
            backgroundColor: theme.palette.primary.bg,
            color: theme.palette.primary.main,
            m: isMobile ? '1rem .4rem 0' : '2rem 14vw 0',
            p: isMobile ? '1rem 1.2rem 0' : '3rem 6vw 0',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            flexWrap: 'wrap',
            minHeight: 600,
        }),
        textSection: {
            flex: 4,
            textAlign: 'left',
            m: 0,
            p: '0 1.2rem',
            fontWeight: 600,
            fontFamily: 'Catamaran',
        },
        banner: (isMobile) => ({
            m: '0 0 2rem 0',
            p: '0 .2rem',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: isMobile ? undefined : 'center',
            height: isMobile ? '60vh' : '74vh',
        }),
        heading: (theme, isMobile) => ({
            fontSize: isMobile ? '2.5rem' : '3.4rem',
            fontFamily: 'inherit',
            fontWeight: 900,
            textAlign: isMobile ? 'center' : 'left',
            color: theme.palette.primary.black,
            mb: 2,
        }),
        headingHighlight: {
            textDecoration: 'underline',
            textDecorationColor: "#ff1493",
            textDecorationThickness: 8,
        },
        subheading: (theme, isMobile) => ({
            fontFamily: 'inherit',
            fontWeight: 600,
            mt: isMobile ? 2 : 1,
            mb: isMobile ? 2.4 : 4,
            maxWidth: '100%',
            color: theme.palette.text.gray,
            fontSize: isMobile ? '1rem' : '1.2rem',
            textAlign: isMobile ? 'center' : 'left',
        }),
        mediaSection: (isMobile) => ({
            flex: 3,
            m: isMobile ? '4rem 0 0 0' : '-10vh 0 0 0',
            alignSelf: 'center',
            p: 0,
        }),
        video: (isMobile) => ({
            m: 0,
            p: 0,
            height: '86vh',
            objectFit: 'contain',
            mt: isMobile ? 4 : 0,
        }),
    }

    return (
        <Box sx={(theme) => styles.container(theme, isMobile)}>

            {/* text section */}
            <Box sx={styles.textSection}>

                <Box sx={styles.banner(isMobile)}>
                    <Typography
                        variant={isMobile ? 'h3' : 'h2'}
                        component="h1"
                        sx={(theme) => styles.heading(theme, isMobile)}
                    >
                        Your link in bio,
                        <br />
                        <span style={styles.headingHighlight}>
                            in a video.
                        </span>
                    </Typography>

                    <Typography
                        variant="h6"
                        component="h4"
                        sx={(theme) => styles.subheading(theme, isMobile)}
                    >
                        Draw attention with your personality and your energy — get the insights that really matter for your personal brand.
                    </Typography>

                    <VibioGetStartedForm />
                </Box>

            </Box>

            {/* media section */}
            <Box sx={styles.mediaSection(isMobile)}>
                <HeroMedia username="moduss" />
                {/* <CardMedia
                    muted
                    playsInline
                    component="video"
                    src="/videos/hero-mockup.mp4"
                    title="Vibio in action mockup"
                    autoPlay
                    loop
                    sx={styles.video(isMobile)}
                /> */}
            </Box>
        </Box>
    )
}
